import React, { useEffect, useState } from 'react';
import '../../../CSS/Puestos.css'
import '../../../CSS/TablaHerramientas.css'
import { getPermission } from '../../../Conexiones/Conexion';
import { BsPlus } from 'react-icons/bs';
import { useNavigate } from "react-router";
import { Button, CloseButton, Modal } from 'react-bootstrap';
import { deleteApi, getApi, postApi, putApi } from '../../../Conexiones/Models';
import { errorMessage, errorToast, successToast, warningModal, warningToast } from '../../../Utils/AlertMessage';
import { FaArrowLeftLong } from 'react-icons/fa6';
import Loading from '../../../Utils/Loading';

function TablaTobra() {
    const navigate = useNavigate();
    const [tiposObra,setipobras]=useState([]);
    const [tablaTipos,setTablaTipos]=useState([]);
    const [busqueda,setBusqueda] = useState ('');
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const uri = 'tiposobra/';
    const [isLoading,setIsLoading]=useState(false);

    //AGREGAR
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [nombreAdd, setNombreAdd] = useState();
    const [isSaving, setSaving] = useState(false);
    //EDITAR
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const [editNombre,setEditNombre] = useState ()
    const [idTipo,setTipo] = useState ()
    const handleShowEdit = (id,nombre) =>{
        setShowEdit(true);
        setEditNombre(nombre);
        setTipo(id);
    } 

    useEffect (()=>{
        const getTipObra = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,8);
            if(permiso){
                const endpoint = uri;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setipobras(res.data)
                        setTablaTipos(res.data)
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        }
        getTipObra()
    },[idUsuario,navigate])

    const getTipObra = async () =>{
        const endpoint = uri;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setipobras(res.data)
                setTablaTipos(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const buscar = e => {
        setBusqueda(e.target.value);
        filtrar(e.target.value);
    }

    const filtrar= (textoIngresado) =>{
        var resultadoBusqueda = tablaTipos.filter((elemento)=> {
            if(elemento.nombreTipoObra.toString().toLowerCase().includes(textoIngresado.toLowerCase())){
                return elemento;
            }
            return resultadoBusqueda;
        });
        setipobras(resultadoBusqueda);
    }

    const regresar = () => {
        navigate('/inicio/Catalogos');
    }
    //ELIMINAR
    const modalEliminar = (id) => {    
        warningModal('¿QUIERES ELIMINAR ESTA TIPO DE OBRA?')
        .then(async (result)  => {
            if (result.isConfirmed) {
                const endpoint = uri + id;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="¡Registro eliminado correctamente!"){
                        getTipObra();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }
    //AGREGAR
    const agregarTObra = async (e) =>{
        setSaving(true)
        e.preventDefault()
        if(nombreAdd.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const endpoint = uri;
            const data = {nombreTipoObra:nombreAdd};
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    handleClose();
                    getTipObra();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false)
    }
    //EDITAR
    const update= async (e) => {
        setSaving(true)
        e.preventDefault()
        if(editNombre.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const endpoint = uri + idTipo;
            const data = {nombreTipoObra:editNombre};
            const res = await putApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="Registro modificado"){
                    handleCloseEdit();
                    getTipObra();
                    successToast("EDITADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false)
    }


    return (
        <div className="tablaHerramientas">
            {
                isLoading ?
                <Loading />:
                <div>
                     <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">tipos de obra</label>
                    </div>
                    <div className='divboton' >                                                                                             
                        <div className='boton'  style={{display:'flex', justifyContent:'space-between'}}>
                            <button style={{justifyContent:'center'}} className="btn btn-light btncolor" onClick={handleShow} type="button">
                            <label className="agregar">TIPO DE OBRA</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                                <input value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" className="form-control"  aria-describedby="basic-addon1"/>   
                        </div>
                    </div>
                    {
                        tiposObra.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="tabla-cajaA">
                                <div className="table tabla">
                                    <table className="table table-hover table-bordered text-uppercase">
                                        <thead className="encabezado">
                                            <tr>
                                                <th > TIPO DE OBRA </th>
                                                <th >ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                        { tiposObra.map( t => {
                                            return (
                                                <tr key={t.idTipoObra}>
                                                    <td valign="middle">{t.nombreTipoObra}</td>
                                                    <td>
                                                        <div>
                                                            <div className="btn iconoH" onClick={() => handleShowEdit(t.idTipoObra,t.nombreTipoObra)} style={{margin:'5px'}}>
                                                                <span className="bi bi-pen" title="EDITAR"></span>
                                                            </div>
                                                            <div className="btn iconoH" style={{margin:'5px'}} onClick={() => modalEliminar(t.idTipoObra)}>
                                                                    <span className="bi bi-trash" title="ELIMINAR"></span>
                                                            </div>                                     
                                                        </div>
                                                    </td>
                                                </tr>
                                                )})
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )
                    }

                    {/*AGREGAR TIPO DE OBRA*/}
                    <Modal show={show} onHide={handleClose} id="modal-agregar-tipo">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR TIPO DE OBRA</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={agregarTObra}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setNombreAdd(e.target.value) } />
                                </div>  
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleClose}>CANCELAR</Button>                                               
                                {isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>  

                    {/*EDITAR TIPO DE OBRA*/}
                    <Modal  show={showEdit} onHide={handleCloseEdit} id="modal-editar-tipo">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR TIPO DE OBRA</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={update}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setEditNombre(e.target.value)} defaultValue={editNombre}/>
                                </div>  
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleCloseEdit}>CANCELAR</Button>                                               
                                {isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>
                </div>
            }
        </div>
    );
}

export default TablaTobra;